import { render } from "./LayoutWarning.vue?vue&type=template&id=6ff63a40&scoped=true"
import script from "./LayoutWarning.vue?vue&type=script&lang=js"
export * from "./LayoutWarning.vue?vue&type=script&lang=js"

import "./LayoutWarning.vue?vue&type=style&index=0&id=6ff63a40&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff63a40"]])

export default __exports__